<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >

    <path
      d="M14.4092 6.40498V5.37177H6.62122L11.2039 9.62216C11.4908 9.88855 11.4869 10.3026 11.1948 10.5645L6.66376 14.6283H14.409V14.0043C14.409 13.6262 14.7657 13.3186 15.2043 13.3186C15.6427 13.3186 15.9998 13.6262 15.9998 14.0043V15.314C15.9998 15.6922 15.6429 16 15.2043 16H4.79565C4.47647 16 4.18906 15.8364 4.06384 15.5828C3.93857 15.3294 4.00093 15.0373 4.22216 14.8387L9.52689 10.0813L4.21308 5.15291C3.99777 4.95297 3.94018 4.66227 4.06648 4.41194C4.19294 4.16171 4.47926 4 4.79565 4H15.2045C15.6429 4 16 4.30763 16 4.68598V6.40498C16 6.78314 15.6431 7.09089 15.2045 7.09089C14.7659 7.09089 14.4092 6.78329 14.4092 6.40498Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'SummationIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
